import { useQuery } from '@apollo/client';
import type { CircleFieldsFragment } from '../gql/graphql';
import { GET_CIRCLES } from '../graphql/resolvers/circleQueries/getCircles.gql';

export function useCircles(): {
  circles: CircleFieldsFragment[];
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery(GET_CIRCLES, {
    fetchPolicy: 'cache-and-network',
  });
  return {
    circles: data?.circles ?? [],
    loading,
    error,
  };
}
